var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:("MaskBox " + _vm.position)},[_c('div',{staticClass:"maskBg",on:{"click":_vm.onMaskBg}}),_c('div',{staticClass:"maskContext"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }